import { FunctionComponent, useCallback, useState } from "react";
import { CollapseIcon } from "@icons/CollapseIcon";
import { ExpandIcon } from "@icons/ExpandIcon";

import "./CollapsableText.css";

interface CollapsableTextProps {
  title: string;
  text: string;
}

const CollapsableText: FunctionComponent<CollapsableTextProps> = ({
  text,
  title,
}) => {
  const [isExpanded, setIsExpanded] = useState(false);

  const handlePress = useCallback(() => {
    setIsExpanded(!isExpanded);
  }, [isExpanded]);

  return (
    <div className="collapsable-text">
      <div className="title">
        {title}
        <span onClick={handlePress} className="icon">
          {isExpanded ? <CollapseIcon size={16} /> : <ExpandIcon size={16} />}
        </span>
      </div>
      <div className={`text ${!isExpanded ? "clamp" : ""}`}>{text}</div>
    </div>
  );
};

export { CollapsableText };
